import React, { useCallback, useEffect, useRef, useState } from 'react';

import { RiWhatsappLine } from 'react-icons/ri';

import { FormHandles } from '@unform/core';

import * as S from './styles';

import Input from '../../newComponents/UnformInput';
import Button from '../../newComponents/Button';

import { useHeader } from '../../hooks/header';
import { useAuth } from '../../hooks/auth';

import api from '../../services/api';
import { useToast } from '../../hooks/toast';
import Toggle from '../../newComponents/Toggle';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface WhatsappProps {}

const Whatsapp: React.FC<WhatsappProps> = () => {
  const formRef = useRef<FormHandles>(null);

  const { user } = useAuth();
  const { addToast } = useToast();
  const {
    whatsappStateLoja,
    whatsappStateGrupo,
    whatsappNumberGrupo,
    whatsappNumberLoja,
    setWhatsappNumberGrupo,
    setWhatsappNumberLoja,
    setWhatsappStateLoja,
    setWhatsappStateGrupo,
  } = useHeader();

  const [isLoading] = useState(false);
  const [statusEnvioCliente, setStatusEnvioCliente] = useState(true);
  const [statusLoja, setStatusLoja] = useState(false);
  const [statusGrupo, setStatusGrupo] = useState(false);
  const [phoneLoja, setPhoneLoja] = useState('');
  const [phoneGrupo, setPhoneGrupo] = useState('');

  const handleChangePhone = useCallback(
    (value: string | undefined, ref: 'loja' | 'grupo') => {
      if (typeof value !== 'string') {
        return;
      }

      if (value.length >= 16) {
        return;
      }

      const maskedValue = value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3');

      if (ref === 'loja') {
        setPhoneLoja(maskedValue);
      } else {
        setPhoneGrupo(maskedValue);
      }
    },
    [],
  );

  const handleChangeWpp = async (data: {
    whatsappLoja: string;
    whatsappGrupo: string;
  }): Promise<void> => {
    const completedata = { ...data, statusLoja, statusGrupo };

    try {
      completedata.whatsappLoja = completedata.whatsappLoja.replace('(', '');
      completedata.whatsappGrupo = completedata.whatsappGrupo.replace('(', '');

      completedata.whatsappLoja = completedata.whatsappLoja.replace(')', '');
      completedata.whatsappGrupo = completedata.whatsappGrupo.replace(')', '');

      completedata.whatsappLoja = completedata.whatsappLoja.replace('-', '');
      completedata.whatsappGrupo = completedata.whatsappGrupo.replace('-', '');

      completedata.whatsappLoja = completedata.whatsappLoja.replace(' ', '');
      completedata.whatsappGrupo = completedata.whatsappGrupo.replace(' ', '');

      await api.post(`/parametro`, {
        descricao: 'whatsapp',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          status: statusGrupo,
          number: completedata.whatsappGrupo,
        }),
      });

      await api.post(`/parametro/loja`, {
        descricao: 'mensagem_cliente',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          status: statusEnvioCliente,
        }),
      });

      await api.post(`/parametro/loja`, {
        descricao: 'whatsapp',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          status: statusLoja,
          number: completedata.whatsappLoja,
        }),
      });

      setWhatsappNumberGrupo(completedata.whatsappGrupo);
      setWhatsappNumberLoja(completedata.whatsappLoja);

      setWhatsappStateLoja(statusLoja);
      setWhatsappStateGrupo(statusGrupo);

      addToast({
        title: `Alterado com sucesso!`,
        type: 'success',
      });
    } catch (err) {
      console.log(err);

      addToast({
        title: 'Algo deu errado',
        type: 'error',
        description: (err as any).response?.data?.message || 'Tente novamente.',
      });
    }
  };

  useEffect(() => {
    async function loadEnvioCliente(): Promise<void> {
      const paramGrupo = await api.get('/parametro/loja', {
        params: {
          descricao: 'mensagem_cliente',
          empresa_id: user.empresa_id,
        },
      });

      setStatusEnvioCliente(
        paramGrupo?.data ? JSON.parse(paramGrupo.data.role).status : true,
      );
    }

    loadEnvioCliente();
  }, [user.empresa_id]);

  useEffect(() => {
    handleChangePhone(whatsappNumberGrupo, 'grupo');
  }, [handleChangePhone, whatsappNumberGrupo]);

  useEffect(() => {
    handleChangePhone(whatsappNumberLoja, 'loja');
  }, [handleChangePhone, whatsappNumberLoja]);

  useEffect(() => {
    setStatusGrupo(whatsappStateGrupo);
  }, [whatsappStateGrupo]);

  useEffect(() => {
    setStatusLoja(whatsappStateLoja);
  }, [whatsappStateLoja]);

  return (
    <S.Container>
      <header>
        <h1>Integração com Whatsapp</h1>
        <p>
          Digite o número do Whatsapp da sua loja e clique no botão
          &quot;Habilitar&quot; para que seus clientes recebam mensagens
          informando a mudança do estágio de seus pedidos
        </p>
      </header>

      <S.CustomForm ref={formRef} onSubmit={handleChangeWpp}>
        <div>
          <Input
            name="whatsappLoja"
            icon={RiWhatsappLine}
            label="Whatsapp da loja:"
            value={phoneLoja}
            onChange={(e) => handleChangePhone(e.target.value, 'loja')}
            placeholder="Ex.: (xx) 9xxxx-xxxx"
            disabled={isLoading}
          />
          <Toggle
            checked={statusLoja}
            firstText="Pausado"
            secondText="Ativado"
            onToggle={(e) => setStatusLoja(e)}
          />
        </div>
        <div>
          <Input
            name="whatsappGrupo"
            icon={RiWhatsappLine}
            label="Whatsapp do grupo:"
            value={phoneGrupo}
            onChange={(e) => handleChangePhone(e.target.value, 'grupo')}
            placeholder="Ex.: (xx) 9xxxx-xxxx"
            disabled={isLoading}
          />
          <Toggle
            checked={statusGrupo}
            firstText="Pausado"
            secondText="Ativado"
            onToggle={(e) => setStatusGrupo(e)}
          />
        </div>
        <div
          style={{
            marginTop: 20,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p
            style={{
              display: 'block',
              marginBottom: 6,
              fontWeight: 500,
              fontSize: 14,
              fontFamily: "'Sora', sans-serif",
              color: '#101d40',
            }}
          >
            Permitir os clientes enviarem mensagens:
          </p>
          <Toggle
            checked={statusEnvioCliente}
            firstText="Pausado"
            secondText="Ativado"
            onToggle={(e) => setStatusEnvioCliente(e)}
          />
        </div>
        <Button full type="submit" disabled={isLoading}>
          Confirmar
        </Button>
      </S.CustomForm>
    </S.Container>
  );
};

export default Whatsapp;
